export default [
  'M31.6 40c-.2 0-.4 0-.6-.1l-11-6.2-11.1 6.2c-.4.2-.9.1-1.2-.1-.4-.3-.6-.7-.5-1.2l2.1-13.1-9-9.2c-.3-.3-.4-.7-.3-1.2.1-.4.5-.7.9-.8l12.4-1.9L18.9.6c.4-.8 1.7-.8 2.1 0l5.6 11.8 12.4 2c.4.1.8.4.9.8.1.4 0 .9-.3 1.2l-9 9.2 2.1 13.1c.1.4-.1.9-.5 1.2-.1 0-.3.1-.6.1z',
];
